// Types
import { column } from "./column.js";
import { stack } from "./stack.js";
export const CalendarEventOverlapModes = {
  stack,
  column
};
//# sourceMappingURL=index.js.map